import { render } from "./crm-region-wrapper.vue?vue&type=template&id=4fb681b7&ts=true"
import script from "./crm-region-wrapper.ts?vue&type=script&lang=ts&external"
export * from "./crm-region-wrapper.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__